module.exports = __webpack_public_path__ + "img/ty.eb962ff7.jpg";